import React from "react";
import ChannelHistory from "./ticketListInfo/ChannelHistory";
import LeadInformation from "./ticketListInfo/LeadInformation";
import Messages from "./ticketListInfo/Messages";
import Tasks from "./ticketListInfo/Tasks";
import Trail from "./ticketListInfo/Trail";
import Attachment from "./ticketListInfo/Attachments";
import { useAuditTrailQuery } from "../../Services/ticket/Audit-Trail";
import { useParams } from "react-router-dom";
import ChildTickets from "./ticketListInfo/ChildTickets";
import "./TicketPaneOpen.scss";

interface IPROPS {
  tickets: any;
  refetch: any;
  taskData: any;
  refetchTask: any;
  isLoading: any;
  refetchAuditTrailForwardedData: any;
  paneOpen: any;
  setPaneOpen: any;
  setConfirmationModalOpen: any;
  confirmationModalOpen: any;
  handleButtonClick: any;
  auditTrailForwardedData: any;
  setDependancyValue: any;
  setStoreLabel: any;
}

const TicketPaneOpen: React.FC<IPROPS> = ({
  tickets,
  refetch,
  taskData,
  refetchTask,
  isLoading,
  refetchAuditTrailForwardedData,
  paneOpen,
  setPaneOpen,
  setConfirmationModalOpen,
  confirmationModalOpen,
  handleButtonClick,
  auditTrailForwardedData,
  setDependancyValue,
  setStoreLabel,
}) => {
  const params = useParams();
  const uuid = params.uuid;

  const { data: auditTrailData, refetch: refetchAuditTrail } =
    useAuditTrailQuery(uuid);

  const tabs = [
    { id: "LeadInformation", label: "Ticket information" },
    { id: "ChannelHistory", label: "Channel history" },
    { id: "Messages", label: "Messages" },
    { id: "Trail", label: "Trail" },
    { id: "Tasks", label: "Tasks", disabled: true },
    { id: "Attachment", label: "Attachment" },
  ];

  if (tickets?.is_child_ticket === false) {
    tabs.push({ id: "childTicket", label: "Child Ticket" });
  }

  return (
    <div className="ticket-pane-open">
      <div className="ticket-tabs-container">
        <div className="ticket-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`ticket-tab 
              ${paneOpen === tab.id ? "active" : ""} 
              ${tab.disabled ? "disabled" : ""}
              `}
              onClick={() => !tab.disabled && setPaneOpen(tab.id)}
              disabled={tab.disabled}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <div className="ticket-content-card">
        {paneOpen === "LeadInformation" ? (
          <LeadInformation
            ticket={tickets}
            refetch={refetch}
            uuid={uuid}
            refetch1={refetchAuditTrail}
            refetchAuditTrailForwardedData={refetchAuditTrailForwardedData}
            setConfirmationModalOpen={setConfirmationModalOpen}
            confirmationModalOpen={confirmationModalOpen}
            handleButtonClick={handleButtonClick}
            setDependancyValue={setDependancyValue}
            setStoreLabel={setStoreLabel}
          />
        ) : paneOpen === "ChannelHistory" ? (
          <ChannelHistory tickets={tickets} refetch={refetch} />
        ) : paneOpen === "Messages" ? (
          <Messages notesData={tickets} fetchingNotes={refetch} />
        ) : paneOpen === "Trail" ? (
          <Trail
            auditTrailData={auditTrailData}
            auditTrailForwardedData={auditTrailForwardedData}
            tickets={tickets}
          />
        ) : paneOpen === "Tasks" ? (
          <Tasks
            taskData={taskData}
            refetchTask={refetchTask}
            isLoading={isLoading}
          />
        ) : paneOpen === "Attachment" ? (
          <Attachment
            data={tickets}
            auditTrailData={auditTrailData}
            refetchAuditTrail={refetchAuditTrail}
            refetch={refetch}
          />
        ) : paneOpen === "childTicket" ? (
          <ChildTickets data={tickets} auditTrailData={auditTrailData} />
        ) : (
          <>SomethingElse</>
        )}
      </div>
    </div>
  );
};

export default TicketPaneOpen;
